import React from 'react'
import styled from 'styled-components'

const Foot = styled.footer`
    margin: 1% 6%;
    padding-top: 1%;
    border-top: 1.5px grey solid;
    display: flex;
    justify-content: center;
    a{
        color: ${props => props.theme.grey};
        text-decoration: none;
        padding: 1%;
        margin-left: 4%;
        margin-right: 4%;
    }
    @media (max-width: ${props => props.theme.mobileBreakpoint}){
        a{
            margin-left: 0%;
            margin-right: 0%;
        }
        min-width: 40%;
        justify-content: space-around;
    }
`

const Div = styled.div`
    background-color: white;
    position: absolute; // absolute
    bottom: 0;
    width: 100%;
    margin-top: -200px;
    /* padding-bottom: 10rem; */
    /* margin-top: 200rem; */
    /* margin-bottom: 10%; */
    text-align: center;
    /* max-height: 170px; */
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        margin-top: -200px;
        max-height: 170px;
    }
`

const P = styled.p`
    padding-bottom: 1.5%;
    color: ${props => props.theme.grey};
    font-size: .85rem;
    @media (max-width: ${props => props.theme.tabletBreakpoint}){
        font-size: .80rem;
    }
`

const Footer = () => {
    return (
        <Div>
            <Foot>
                <a href="https://instagram.com/ngenviroclub" target="_blank" rel="noopener noreferrer"><i class="fab fa-instagram fa-2x"></i></a>
                <a href="mailto:nghsenvironment@gmail.com"><i class="far fa-envelope fa-2x"></i></a>
            </Foot>
            <P>Copyright &copy; {(new Date().getFullYear())} NGHS ENVIRONMENTAL. All rights reserved.</P>
        </Div>
    )
}

export default Footer